import formatCourseIcon from "@assets/images/shareroom/course-format-icon.svg";
import objectiveIcon from "@assets/images/shareroom/goals-icon.svg";
import presentationIcon from "@assets/images/shareroom/presentation-icon.svg";
import scheduleIcon from "@assets/images/shareroom/schedule-icon.svg";
import targetAudienceIcon from "@assets/images/shareroom/target-icon.svg";
import { AboutShareroomDraftField } from "@domain/group/shareroom/shareroom";

export const ShareroomBlocIcons: { [key in AboutShareroomDraftField]: string } = {
	presentation: presentationIcon,
	objective: objectiveIcon,
	targetAudience: targetAudienceIcon,
	schedule: scheduleIcon,
	formatCourse: formatCourseIcon,
} as const;

type ShareroomBloc = keyof typeof ShareroomBlocIcons;

export const ShareroomBlocs = Object.keys(ShareroomBlocIcons) as ShareroomBloc[];
